/*
 * ce-video-fullscreen.js — PDP video row: starting a video opens it in the device's native full-screen player.
 * WHY JS: full screen is only reachable through an API call. iPhone needs none — the <video> is rendered without
 * `playsinline`, so the first play() (Dawn's DeferredMedia, inside the tap) presents the native player by itself.
 * Everywhere else `requestFullscreen()` is called from the same click gesture (and from later `play` events, i.e.
 * the inline controls once the poster is gone). Leaving full screen pauses the video. One delegated click listener
 * per row; nothing runs before the first tap.
 */
(() => {
  const rows = document.querySelectorAll('.ce-pd-videos');
  if (!rows.length) return;
  const iphone = /iPhone|iPod/.test(navigator.userAgent);

  const enter = (video) => {
    if (iphone) return; // the native player is already presented by play() (no `playsinline`)
    if (document.fullscreenElement === video || video.dataset.ceFs === 'pending') return;
    const request = video.requestFullscreen || video.webkitRequestFullscreen;
    if (request) {
      video.dataset.ceFs = 'pending';
      const result = request.call(video);
      if (result && result.catch) result.catch(() => delete video.dataset.ceFs);
    } else if (video.webkitEnterFullscreen) {
      try { video.webkitEnterFullscreen(); } catch (error) { /* metadata not loaded yet */ }
    }
  };

  const bind = (video) => {
    if (video.dataset.ceFsBound) return;
    video.dataset.ceFsBound = 'true';
    video.addEventListener('play', () => enter(video));
    video.addEventListener('webkitendfullscreen', () => video.pause()); // iOS native player closed
    video.addEventListener('fullscreenchange', () => {
      if (document.fullscreenElement !== video) {
        delete video.dataset.ceFs;
        video.pause();
      }
    });
  };

  rows.forEach((row) => {
    row.addEventListener('click', (event) => {
      const poster = event.target.closest('.deferred-media__poster');
      if (!poster) return;
      // DeferredMedia listens on the poster itself, so it has already appended the <video> and called play().
      const video = poster.closest('deferred-media')?.querySelector('video');
      if (!video) return;
      bind(video);
      enter(video);
    });
  });
})();
